(function(d) {
  'use strict';

  $('.nav-search-open-button').click(function(e) {
    e.preventDefault();
    $('.header__content').addClass('header__content--search-visible');
    $('.header__content .nav-search__keywords').select().focus();
  });
  $('.nav-search-close-button').click(function(e) {
    e.preventDefault();
    $('.header__content').removeClass('header__content--search-visible');
  });

  // Since Yahoo search assistant can only be initialized onto one element, we need to check which element is being shown
  // Left nav form will be shown on small screens while header search will be shown on big screens
  // Check if left-nav-search-input is visible. Otherwise, assume header-search-input is visible
  var $yahooSearchInput = $('#left-nav-search-input:visible');

  if (!$yahooSearchInput.length) {
      $yahooSearchInput = $('#header-search-input');
  }
  var input = $yahooSearchInput[0];
  var initParams = $yahooSearchInput.data('yahooSearchParams');

  if (input && initParams) {
    // Yahoo search assist input present. Async-ly load assistjs
    var sdk = d.createElement('script');
    sdk.src = 'https://s.yimg.com/pv/static/assistjs/desktop-v1.0.70.js';
    sdk.async = true;
    sdk.onload = function() {
      window.YAHOO.SA.init(initParams);
    };
    d.body.appendChild(sdk);
  }
})(document);